import { Button, Grid } from '@mui/material'
import React from 'react'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export const OpcionesMenuFunc = ({ opciones, handleEvent, small, variant, justifyContent }) => {
    const iconMapping = {
        AddCircleIcon: <AddCircleIcon />,
        PersonAddAltIcon: <PersonAddAltIcon />,
        DeleteForeverIcon: <DeleteForeverIcon />,
        EditIcon: <EditIcon />,
        VisibilityOffIcon: <VisibilityOffIcon />
    };
    return (
        <Grid
            container
            direction="row"
            xs={12}
            justifyContent={justifyContent ?? "space-evenly"}
            alignItems="center"
        // spacing={1}
        // marginBottom={1}
        >
            {opciones && opciones.length >= 1 && (
                opciones.map((opcion, index) => (
                    <Grid
                        xs={5} sm={3} md={3} lg={2} xl={'auto'}
                        key={index}
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Button
                            fullWidth
                            variant={variant ?? 'contained'}
                            size={small ? "small" : "medium"}
                            // className='button-default'
                            onClick={() => handleEvent(opcion.id_opcion ? opcion.id_opcion : opcion.id)}
                            disabled={false}
                        >
                            {iconMapping[opcion.icon] && (
                                <>
                                    {iconMapping[opcion.icon]}{opcion.nombre ? "  " : ""}
                                </>
                            )}
                            &nbsp; {opcion.nombre || ""}
                        </Button>
                    </Grid>
                ))
            )}
        </Grid>
    )
}
